import { render, staticRenderFns } from "./HomeServicesCarousel.vue?vue&type=template&id=03654b6e&scoped=true&"
import script from "./HomeServicesCarousel.vue?vue&type=script&lang=ts&"
export * from "./HomeServicesCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./HomeServicesCarousel.vue?vue&type=style&index=0&id=03654b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03654b6e",
  null
  
)

export default component.exports